const KOUSSA_ENDPOINT = 'email-exists';
function getEmailExists(gateway, params, customURL = null, customHeaders = null) {
    return gateway.post(getEmailExists.koussaEndpoint, {}, { email: params.email }, customURL, customHeaders, 'json', true);
}
getEmailExists.koussaEndpoint = KOUSSA_ENDPOINT;

export { getEmailExists as default, getEmailExists };
//# sourceMappingURL=getEmailExists.js.map
